module.exports = __webpack_public_path__ + "fd3d92d65cdcf7227110995d8d488614.svg";